export default "__VITE_ASSET__813eab78__"